/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  InvestorCreateDataRequest
} from '../../model/investorCreateDataRequest'
import type {
  InvestorEditDataRequest
} from '../../model/investorEditDataRequest'
import type {
  InvestorEntityRelationshipReadDataList
} from '../../model/investorEntityRelationshipReadDataList'
import type {
  InvestorEntityRelationshipsAPIDataRequest
} from '../../model/investorEntityRelationshipsAPIDataRequest'
import type {
  InvestorEntityRelationshipsDestroyParams
} from '../../model/investorEntityRelationshipsDestroyParams'
import type {
  InvestorListParams
} from '../../model/investorListParams'
import type {
  InvestorReadData
} from '../../model/investorReadData'
import type {
  InvestorReadDataList
} from '../../model/investorReadDataList'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * List investors
 */
export const investorList = (
    params?: InvestorListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorReadDataList>(
      {url: `/investor/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInvestorListQueryKey = (params?: InvestorListParams,) => {
    return [`/investor/`, ...(params ? [params]: [])] as const;
    }

    
export const getInvestorListQueryOptions = <TData = Awaited<ReturnType<typeof investorList>>, TError = unknown>(params?: InvestorListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorList>>> = ({ signal }) => investorList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorListQueryResult = NonNullable<Awaited<ReturnType<typeof investorList>>>
export type InvestorListQueryError = unknown

export const useInvestorList = <TData = Awaited<ReturnType<typeof investorList>>, TError = unknown>(
 params?: InvestorListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorList>>, TError = unknown>(params?: InvestorListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorList>>> = ({ signal }) => investorList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorList>>>
export type InvestorListSuspenseQueryError = unknown

export const useInvestorListSuspense = <TData = Awaited<ReturnType<typeof investorList>>, TError = unknown>(
 params?: InvestorListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorListLoader = (queryParamsOrFn?: (InvestorListParams | ((params: Params) => InvestorListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getInvestorListQueryKey(queryParams),
            queryFn: () => investorList(queryParams),
          }).then(() => null);
        });
      /**
 * Create a new investor and associate it with an existing investor entity
 */
export const investorCreate = (
    investorCreateDataRequest: InvestorCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorReadData>(
      {url: `/investor/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investorCreateDataRequest
    },
      options);
    }
  


export const getInvestorCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorCreate>>, TError,{data: InvestorCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorCreate>>, TError,{data: InvestorCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorCreate>>, {data: InvestorCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  investorCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorCreateMutationResult = NonNullable<Awaited<ReturnType<typeof investorCreate>>>
    export type InvestorCreateMutationBody = InvestorCreateDataRequest
    export type InvestorCreateMutationError = unknown

    export const useInvestorCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorCreate>>, TError,{data: InvestorCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get an existing investor
 */
export const investorRetrieve = (
    investorId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorReadData>(
      {url: `/investor/${investorId}`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorRetrieveQueryKey = (investorId: string,) => {
    return [`/investor/${investorId}`] as const;
    }

    
export const getInvestorRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investorRetrieve>>, TError = unknown>(investorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorRetrieveQueryKey(investorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorRetrieve>>> = ({ signal }) => investorRetrieve(investorId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(investorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investorRetrieve>>>
export type InvestorRetrieveQueryError = unknown

export const useInvestorRetrieve = <TData = Awaited<ReturnType<typeof investorRetrieve>>, TError = unknown>(
 investorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorRetrieveQueryOptions(investorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorRetrieve>>, TError = unknown>(investorId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorRetrieveQueryKey(investorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorRetrieve>>> = ({ signal }) => investorRetrieve(investorId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(investorId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorRetrieve>>>
export type InvestorRetrieveSuspenseQueryError = unknown

export const useInvestorRetrieveSuspense = <TData = Awaited<ReturnType<typeof investorRetrieve>>, TError = unknown>(
 investorId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorRetrieveSuspenseQueryOptions(investorId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ investorId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { investorId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (investorId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorRetrieveQueryKey(investorId),
              queryFn: () => investorRetrieve(investorId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edit an existing investor
 */
export const investorUpdate = (
    investorId: string,
    investorEditDataRequest: InvestorEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorReadData>(
      {url: `/investor/${investorId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: investorEditDataRequest
    },
      options);
    }
  


export const getInvestorUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorUpdate>>, TError,{investorId: string;data: InvestorEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorUpdate>>, TError,{investorId: string;data: InvestorEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorUpdate>>, {investorId: string;data: InvestorEditDataRequest}> = (props) => {
          const {investorId,data} = props ?? {};

          return  investorUpdate(investorId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof investorUpdate>>>
    export type InvestorUpdateMutationBody = InvestorEditDataRequest
    export type InvestorUpdateMutationError = unknown

    export const useInvestorUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorUpdate>>, TError,{investorId: string;data: InvestorEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete an existing investor
 */
export const investorDestroy = (
    investorId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/investor/${investorId}`, method: 'DELETE'
    },
      options);
    }
  


export const getInvestorDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorDestroy>>, TError,{investorId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorDestroy>>, TError,{investorId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorDestroy>>, {investorId: string}> = (props) => {
          const {investorId} = props ?? {};

          return  investorDestroy(investorId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof investorDestroy>>>
    
    export type InvestorDestroyMutationError = unknown

    export const useInvestorDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorDestroy>>, TError,{investorId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create an association between an investor and and one or more investor entities
 */
export const investorEntityRelationshipCreate = (
    investorId: string,
    investorEntityRelationshipsAPIDataRequest: InvestorEntityRelationshipsAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorEntityRelationshipReadDataList>(
      {url: `/investor/${investorId}/investor-entity-relationships/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investorEntityRelationshipsAPIDataRequest
    },
      options);
    }
  


export const getInvestorEntityRelationshipCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityRelationshipCreate>>, TError,{investorId: string;data: InvestorEntityRelationshipsAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorEntityRelationshipCreate>>, TError,{investorId: string;data: InvestorEntityRelationshipsAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorEntityRelationshipCreate>>, {investorId: string;data: InvestorEntityRelationshipsAPIDataRequest}> = (props) => {
          const {investorId,data} = props ?? {};

          return  investorEntityRelationshipCreate(investorId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorEntityRelationshipCreateMutationResult = NonNullable<Awaited<ReturnType<typeof investorEntityRelationshipCreate>>>
    export type InvestorEntityRelationshipCreateMutationBody = InvestorEntityRelationshipsAPIDataRequest
    export type InvestorEntityRelationshipCreateMutationError = unknown

    export const useInvestorEntityRelationshipCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityRelationshipCreate>>, TError,{investorId: string;data: InvestorEntityRelationshipsAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorEntityRelationshipCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Remove an investor entity from an investor
 */
export const investorEntityRelationshipsDestroy = (
    investorId: string,
    params: InvestorEntityRelationshipsDestroyParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/investor/${investorId}/investor-entity-relationships/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getInvestorEntityRelationshipsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityRelationshipsDestroy>>, TError,{investorId: string;params: InvestorEntityRelationshipsDestroyParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorEntityRelationshipsDestroy>>, TError,{investorId: string;params: InvestorEntityRelationshipsDestroyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorEntityRelationshipsDestroy>>, {investorId: string;params: InvestorEntityRelationshipsDestroyParams}> = (props) => {
          const {investorId,params} = props ?? {};

          return  investorEntityRelationshipsDestroy(investorId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorEntityRelationshipsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof investorEntityRelationshipsDestroy>>>
    
    export type InvestorEntityRelationshipsDestroyMutationError = unknown

    export const useInvestorEntityRelationshipsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityRelationshipsDestroy>>, TError,{investorId: string;params: InvestorEntityRelationshipsDestroyParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorEntityRelationshipsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    